// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'retailerName',
                    value: 'Retailer Name'
                },
                {
                    key: 'customerName',
                    value: 'Customer Name'
                },
                {
                    key: 'model',
                    value: 'Model'
                },
                {
                    key: 'deliveryDate',
                    value: 'Delivery Date'
                },
                {
                    key: 'legacyCustomer',
                    value: 'Legacy Customer'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'pin',
                    order: 'DESC',
                    value: 'PIN'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/state/views.js